import React, { useEffect, useMemo, useState } from 'react';
import { Card, Col, Form, Pagination, Row, Table } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import { getReportsData } from '../../service/apiService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileExcel,
  faFilePdf,
  faPrint,
} from '@fortawesome/free-solid-svg-icons';

const reports = [['dashboard','Dashboard Report'],['admission','Admission Report'],['intern','Intern Report'],['fee-collection','Fee Collection Report'],['pending-fee','Pending Fee Report'],['student-ledger','Student Ledger'],['intern-ledger','Intern Ledger'],['course-wise','Course-wise Report'],['internship-wise','Internship-wise Report'],['daily-collection','Daily Collection'],['monthly-collection','Monthly Collection'],['yearly-collection','Yearly Collection'],['payment-history','Payment History'],['staff','Staff Report'],['new-admissions','New Admissions'],['new-interns','New Interns'],['activity','Complete Activity Report']];
const money = (v) => Number(v || 0).toFixed(2);

function Reports() {
  const [filter, setFilter] = useState({ report: 'dashboard', search: '', from_date: '', to_date: '', student_type: '' });
  const [rows, setRows] = useState([]);
  const [summary, setSummary] = useState({});
  const [page, setPage] = useState(1);
  const perPage = 10;
  const visible = useMemo(() => rows.slice((page - 1) * perPage, page * perPage), [rows, page]);
  const totalPages = Math.ceil(rows.length / perPage) || 1;

  useEffect(() => {
    const load = async () => {
      const res = await getReportsData(filter);
      if (res.status === 'success') { setRows(res.data || []); setSummary(res.summary || {}); setPage(1); }
    };
    load();
  }, [filter]);

  const columns = rows.length ? Object.keys(rows[0]).filter((k) => k !== 'password') : ['Data'];
  const print = () => window.print();
  const exportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Report');
    XLSX.writeFile(wb, `${filter.report}.xlsx`);
  };

  return (
    <div>
      <h3>Reports</h3>
      <Row className="g-3 mb-3">
        <Col md={2}><Card className="p-3"><small>Total Students</small><h4>{summary.total_students || 0}</h4></Card></Col>
        <Col md={2}><Card className="p-3"><small>Total Interns</small><h4>{summary.total_interns || 0}</h4></Card></Col>
        <Col md={2}><Card className="p-3"><small>Total Staff</small><h4>{summary.total_staff || 0}</h4></Card></Col>
        <Col md={2}><Card className="p-3"><small>Today</small><h4>₹ {money(summary.today_collection)}</h4></Card></Col>
        <Col md={2}><Card className="p-3"><small>Monthly</small><h4>₹ {money(summary.monthly_collection)}</h4></Card></Col>
        <Col md={2}><Card className="p-3"><small>Pending</small><h4>₹ {money(summary.pending_fees)}</h4></Card></Col>
      </Row>
      {/* <Card className="p-3"> */}
        <Row className="g-2 mb-3">
          <Col md={3}><Form.Select value={filter.report} onChange={(e) => setFilter({ ...filter, report: e.target.value })}>{reports.map(([v,l]) => <option key={v} value={v}>{l}</option>)}</Form.Select></Col>
          <Col md={3}><Form.Control placeholder="Search" value={filter.search} onChange={(e) => setFilter({ ...filter, search: e.target.value })} /></Col>
          <Col md={2}><Form.Control type="date" value={filter.from_date} onChange={(e) => setFilter({ ...filter, from_date: e.target.value })} /></Col>
          <Col md={2}><Form.Control type="date" value={filter.to_date} onChange={(e) => setFilter({ ...filter, to_date: e.target.value })} /></Col>
          <Col md="auto">
  <div className="d-flex align-items-center gap-3">

    <FontAwesomeIcon
      icon={faFileExcel}
      className="text-success action-icon"
      title="Export Excel"
      onClick={exportExcel}
    />

    <FontAwesomeIcon
      icon={faFilePdf}
      className="text-danger action-icon"
      title="Export PDF"
      onClick={print}
    />

    <FontAwesomeIcon
      icon={faPrint}
      className="text-primary action-icon"
      title="Print Report"
      onClick={print}
    />

  </div>
</Col>
        </Row>
        <Table bordered hover responsive><thead><tr>{columns.map((c) => <th key={c}>{c.replaceAll('_',' ')}</th>)}</tr></thead><tbody>{visible.length ? visible.map((r, i) => <tr key={i}>{columns.map((c) => <td key={c}>{r[c]}</td>)}</tr>) : <tr><td colSpan={columns.length}>No data</td></tr>}</tbody></Table>
        <div className="d-flex justify-content-between"><b>Total Records: {rows.length}</b><Pagination>{[...Array(totalPages)].map((_, i) => <Pagination.Item key={i+1} active={page===i+1} onClick={() => setPage(i+1)}>{i+1}</Pagination.Item>)}</Pagination></div>
      {/* </Card> */}
    </div>
  );
}

export default Reports;
